import pluralize from 'pluralize'

import { formatMessage } from '~/brands'
import { ListingMeta } from '~/models/Listing/interface'
// import IntlService from '~/services/IntlService'

export const buildMeta = (
  params: any,
  item: string,
  metaSearch: ListingMeta,
  count: any
) => {
  const { by_type, by_make, by_location } = params

  // let price = ''
  // let priceForTitle = ''
  // if (price_min && price_max) {
  //   if (
  //     +metaSearch.min_price !== +price_min &&
  //     +metaSearch.max_price !== +price_max
  //   ) {
  //     price = `between A$${price_min} & A$${price_max}`
  //     priceForTitle = `between ${IntlService.compactFormat(
  //       price_min
  //     )} & ${IntlService.compactFormat(price_max)}`
  //   }
  //   if (+metaSearch.min_price === +price_min) {
  //     price = `under A$${price_max}`
  //     priceForTitle = `under ${IntlService.compactFormat(price_max)}`
  //   }
  //   if (+metaSearch.max_price === +price_max) {
  //     price = `over A$${price_min}`
  //     priceForTitle = `over ${IntlService.compactFormat(price_min)}`
  //   }
  // }

  const location = by_location || 'Australia'
  const makeQuery = by_make && by_make.length === 1 ? by_make : ''
  const locationQuery =
    by_location && by_location.length === 1 ? by_location : null

  const title = `${count || 0} ${makeQuery} ${pluralize(
    by_type || (by_make ? '' : item),
    count
  )} For Sale in ${locationQuery || 'Australia'}`

  if (by_make) {
    return {
      meta: {
        title: formatMessage('searchPage.metaWithBrands.title', {
          values: {
            type: by_type || '',
            location,
            brand: by_make
          }
        }),
        description: formatMessage('searchPage.metaWithBrands.description', {
          values: {
            type: by_type || '',
            location,
            brand: by_make
          }
        })
      },
      title
    }
  }

  return {
    meta: {
      title: formatMessage('searchPage.meta.title', {
        values: {
          type: by_type || item,
          location
        }
      }),
      description: formatMessage('searchPage.meta.description', {
        values: {
          type: by_type || item,
          location
        }
      })
    },
    title
  }
}
